/**
 * @generated SignedSource<<d88ed69a80309fc3d34309ad92e78547>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptModalContentStats$data = {
  readonly id: string;
  readonly meetingCallEnd: string | null;
  readonly meetingCallStart: string;
  readonly meetingRecordedVideoDuration: number | null;
  readonly meetingStats: {
    readonly actualEndTime: number;
    readonly actualStartTime: number;
    readonly userStats: ReadonlyArray<{
      readonly absent: boolean;
      readonly email: string | null;
      readonly fullName: string;
      readonly image: string | null;
      readonly isGuest: boolean | null;
      readonly isTopUser: boolean | null;
      readonly joinedAt: number;
      readonly leftAt: number;
      readonly percentage: number;
      readonly totalTalkTime: number;
    }>;
  } | null;
  readonly " $fragmentType": "TranscriptModalContentStats";
};
export type TranscriptModalContentStats$key = {
  readonly " $data"?: TranscriptModalContentStats$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModalContentStats">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TranscriptModalContentStatsRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "TranscriptModalContentStats",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingStats",
      "kind": "LinkedField",
      "name": "meetingStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingStatsUser",
          "kind": "LinkedField",
          "name": "userStats",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTopUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "absent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalTalkTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "percentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "joinedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leftAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualStartTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualEndTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "e59f41fee8e77c2e65c31b0cc341a708";

export default node;
